export default function useResolveCondition(inactivation) {
  return inactivation.note === 'Required documents are missing'
    || (inactivation.inactivation_reason === 'Admin' && inactivation.created_by === 'System' && inactivation.note === 'New Registration')
    || (inactivation.inactivation_reason === 'Blocked by admin' && inactivation.inactivation_reason_id === 'd636af3d-c62e-430b-9d4b-1b0b75ef2b9f')
    || (inactivation.inactivation_reason === 'data migration')
    || (inactivation.inactivation_reason === 'Liveness Check')
    || (inactivation.inactivation_reason === 'Driver Shift')
    || (inactivation.inactivation_reason === 'Learning Center Block')
}
